export let Locale = {
    pl: {
      dropdowns: {
        noRecordsTemplate: "Brak rekordów",
        actionFailureTemplate: "Nie można pobrać danych",
        overflowCountTemplate: "+${count} więcej..",
        selectAllText: "Zaznacz wszystko",
        unSelectAllText: "Odznacz wszystko"
      },
      calendar: { today: "Dzisiaj" },
      chart: {
        ZoomIn: "Przybliż",
        ZoomOut: "Oddal",
        Zoom: "Zoom",
        Pan: "Przesuń",
        Reset: "Reset",
        ResetZoom: "Reset Przybliżenia"
      },
      datepicker: { placeholder: "Wybierz datę", today: "Dzisiaj" },
      daterangepicker: {
        placeholder: "Wybierz przedział",
        startLabel: "Początek",
        endLabel: "Koniec",
        applyText: "Zatwierdź",
        cancelText: "Anuluj",
        selectedDays: "Wybrane dni",
        days: "Dni",
        customRange: "Własny zakres"
      },
      datetimepicker: { placeholder: "Wybierz datę i godzine", today: "Dzisiaj" },
      dialog: { close: "Zamknij" },
      grid: {
        EmptyRecord: "No records to display",
        True: "true",
        False: "false",
        InvalidFilterMessage: "Invalid Filter Data",
        GroupDropArea: "Drag a column header here to group its column",
        UnGroup: "Click here to ungroup",
        GroupDisable: "Grouping is disabled for this column",
        FilterbarTitle: "filter bar cell",
        EmptyDataSourceError:
          "DataSource must not be empty at initial load since columns are generated from dataSource in AutoGenerate Column Grid",
        Add: "Add",
        Edit: "Edit",
        Cancel: "Cancel",
        Update: "Update",
        Delete: "Delete",
        Print: "Print",
        Pdfexport: "PDF Export",
        Excelexport: "Excel Export",
        Wordexport: "Word Export",
        Csvexport: "CSV Export",
        Search: "Search",
        Columnchooser: "Columns",
        Save: "Save",
        Item: "item",
        Items: "items",
        EditOperationAlert: "No records selected for edit operation",
        DeleteOperationAlert: "No records selected for delete operation",
        SaveButton: "Save",
        OKButton: "OK",
        CancelButton: "Cancel",
        EditFormTitle: "Details of ",
        AddFormTitle: "Add New Record",
        BatchSaveConfirm: "Are you sure you want to save changes?",
        BatchSaveLostChanges:
          "Unsaved changes will be lost. Are you sure you want to continue?",
        ConfirmDelete: "Are you sure you want to Delete Record?",
        CancelEdit: "Are you sure you want to Cancel the changes?",
        ChooseColumns: "Choose Column",
        SearchColumns: "search columns",
        Matchs: "No Matches Found",
        FilterButton: "Filter",
        ClearButton: "Clear",
        StartsWith: "Starts With",
        EndsWith: "Ends With",
        Contains: "Contains",
        Equal: "Equal",
        NotEqual: "Not Equal",
        LessThan: "Less Than",
        LessThanOrEqual: "Less Than Or Equal",
        GreaterThan: "Greater Than",
        GreaterThanOrEqual: "Greater Than Or Equal",
        ChooseDate: "Choose a Date",
        EnterValue: "Enter the value",
        Copy: "Copy",
        Group: "Group by this column",
        Ungroup: "Ungroup by this column",
        autoFitAll: "Auto Fit all columns",
        autoFit: "Auto Fit this column",
        Export: "Export",
        FirstPage: "First Page",
        LastPage: "Last Page",
        PreviousPage: "Previous Page",
        NextPage: "Next Page",
        SortAscending: "Sort Ascending",
        SortDescending: "Sort Descending",
        EditRecord: "Edit Record",
        DeleteRecord: "Delete Record",
        FilterMenu: "Filter"
      },
      checkboxFilter: {
        Search: "Search",
        OK: "OK",
        Cancel: "Cancel",
        Filter: "Filter",
        Clear: "Clear",
        SelectAll: "Select All",
        Blanks: "Blanks",
        True: "True",
        False: "False",
        NoResult: "No Matches Found"
      },
      excelFilter: {
        ClearFilter: "Clear Filter",
        NumberFilter: "Number Filters",
        TextFilter: "Text Filters",
        DateFilter: "Date Filters",
        MatchCase: "Match Case",
        Equal: "Equal",
        NotEqual: "Not Equal",
        LessThan: "Less Than",
        LessThanOrEqual: "Less Than Or Equal",
        GreaterThan: "Greater Than",
        GreaterThanOrEqual: "Greater Than Or Equal",
        Between: "Between",
        CustomFilter: "Custom Filter",
        StartsWith: "Starts With",
        EndsWith: "Ends With",
        Contains: "Contains",
        OK: "OK",
        Cancel: "Cancel",
        CustomFilterPlaceHolder: "Enter the value",
        CustomFilterDatePlaceHolder: "Choose a date",
        AND: "AND",
        OR: "OR",
        ShowRowsWhere: "Show rows where:"
      },
      pager: {
        currentPageInfo: "{0} of {1} pages",
        totalItemsInfo: "({0} items)",
        firstPageTooltip: "Go to first page",
        lastPageTooltip: "Go to last page",
        nextPageTooltip: "Go to next page",
        previousPageTooltip: "Go to previous page",
        nextPagerTooltip: "Go to next pager",
        previousPagerTooltip: "Go to previous pager",
        pagerDropDown: "Items per page"
      },
      numerictextbox: {
        incrementTitle: "Increment value",
        decrementTitle: "Decrement value"
      },
      schedule: {
        day: "Dzień",
        week: "Tydzień",
        workWeek: "Tydzień roboczy",
        month: "Miesiąc",
        agenda: "Agenda",
        weekAgenda: "Tygodniowa Agenda",
        workWeekAgenda: "Agenda tygodnia roboczego",
        monthAgenda: "Miesięczna Agenda",
        today: "Dzisiaj",
        noEvents: "Brak wizyt",
        allDay: "Cały dzień",
        start: "Początek",
        end: "Koniec",
        more: "więcej",
        close: "Zamknij",
        cancel: "Anuluj",
        noTitle: "(Brak opisu)",
        delete: "Usuń",
        deleteEvent: "Usuń Wizyte",
        selectedItems: "Wybrane elementy",
        deleteSeries: "Usuń serie",
        edit: "Edytuj",
        editSeries: "Edytuj serie",
        editEvent: "Edytuj wizyte",
        createEvent: "Stwórz",
        subject: "Temat",
        addTitle: "Dodaj tytuł",
        moreDetails: "Więcej szczegółów",
        save: "Zapisz",
        editContent: "Chcesz edytować tylko tę wizyte czy cała serie?",
        deleteRecurrenceContent:
          "Chcesz usunąć tę wizytę czy całą serie?",
        deleteContent: "Czy na pewno chcesz usunąć tę wizyte?",
        newEvent: "Nowa wizyta",
        title: "Tytuł",
        location: "Lokalizacja",
        description: "Opis",
        timezone: "Strefa czasowa",
        startTimezone: "Początkowa strefa czasowa",
        endTimezone: "Końcowa strefa czasowa",
        repeat: "Powtórz",
        saveButton: "Zapisz",
        cancelButton: "Anuluj",
        deleteButton: "Usuń",
        recurrence: "Powtórzenie",
        editRecurrence: "Edytuj Powtórzenie",
        repeats: "Ilość powtórzeń",
        alert: "Ostrzeżenie",
        startEndError: "Wybrana data końcowa nie może być mniejsza niż data początkowa.",
        invalidDateError: "Wprowadzona data jest nieprawidłowa.",
        ok: "Ok"
      },
      recurrenceeditor: {
        none: "Żaden",
        daily: "Dzienne",
        weekly: "Tygodniowe",
        monthly: "Miesięczne",
        month: "Miesiąc",
        yearly: "Rocznie",
        never: "Nigdy",
        until: "Dopóki",
        count: "Ilość",
        first: "Pierwszy",
        second: "Drugi",
        third: "Trzeci",
        fourth: "Czwarty",
        last: "Ostatni",
        repeat: "Powtórz",
        repeatEvery: "Powórz każdorazowo",
        on: "Powtórz na",
        end: "Koniec",
        onDay: "Dzień",
        days: "Dni",
        weeks: "Tygodnie",
        months: "Miesiące",
        years: "Lata",
        every: "każdy",
        summaryTimes: "razy",
        summaryOn: "na",
        summaryUntil: "dopóki",
        summaryRepeat: "Powtórzenia",
        summaryDay: "dni",
        summaryWeek: "tygodni",
        summaryMonth: "miesięcy",
        summaryYear: "lata"
      },
      slider: { incrementTitle: "zwiększ", decrementTitle: "zmniejsz" },
      timepicker: { placeholder: "Wybierz godzine" },
      uploader: {
        invalidMinFileSize: "File size is too small!",
        invalidMaxFileSize: "File size exceeds 28 MB",
        invalidFileType: "File type is not allowed",
        Browse: "Browse...",
        Clear: "Clear",
        Upload: "Upload",
        dropFilesHint: "Or drop files here",
        uploadFailedMessage: "File failed to upload",
        uploadSuccessMessage: "File uploaded successfully",
        removedSuccessMessage: "File removed successfully",
        removedFailedMessage: "Unable to remove file",
        inProgress: "Uploading",
        readyToUploadMessage: "Ready to upload",
        remove: "Remove",
        cancel: "Cancel",
        delete: "Delete file",
        abort: "Abort",
        pauseUpload: "File upload paused",
        pause: "Pause",
        resume: "Resume",
        retry: "Retry",
        fileUploadCancel: "File upload canceled"
      },
      colorpicker: {
        Apply: "Apply",
        Cancel: "Cancel",
        ModeSwitcher: "Switch Mode"
      }
    }    
  };
  